export const classNames = (...classNamesProp) => {
  const resultClasses = [];

  classNamesProp.forEach((className) => {
    if (className === undefined) {
      return;
    }

    if (typeof className === "string") {
      return resultClasses.push(className);
    }

    Object.keys(className).forEach((key) => {
      if (className[key]) {
        resultClasses.push(key);
      }
    });
  });

  return resultClasses.join(" ");
};
